<div class="flex flex-col gap-4">
    @for (itemControl of control().controls; track itemControl; let index = $index) {
        <div class="flex items-start gap-4">
            <div class="min-w-0 flex-1">
                <ng-container
                    [ngTemplateOutlet]="itemTemplate()"
                    [ngTemplateOutletContext]="{ $implicit: itemControl, index }"
                />
            </div>

            <button
                type="button"
                class="btn btn-circle btn-ghost"
                [attr.aria-label]="removeLabel() | translate: { index: index + 1 }"
                [disabled]="!canRemove()"
                (click)="removeItem(index)"
            >
                <i class="element-delete icon"></i>
            </button>
        </div>
    }

    <button class="btn btn-tertiary self-start pl-0" type="button" [disabled]="!canAdd()" (click)="addItem()">
        <i class="element-plus icon"></i>
        {{ addLabel() | translate }}
    </button>
</div>
